var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseTerrainProvider } from "./BaseTerrainProvider";
import { Rectangle } from "../../math";
import { BufferAttribute, BufferGeometry, Uint16BufferAttribute, Vector2 } from "three";
import { EllipsoidTessellator } from "../../tesselators";
export class TessellatorTerrainProvider extends BaseTerrainProvider {
    constructor(tilingScheme, options) {
        var _a, _b, _c, _d, _e;
        super();
        this._tilingScheme = tilingScheme;
        this._tessellator = new EllipsoidTessellator(tilingScheme);
        this._subdivisions = new Vector2((_b = (_a = options === null || options === void 0 ? void 0 : options.subdivisions) === null || _a === void 0 ? void 0 : _a.longitude) !== null && _b !== void 0 ? _b : 16, (_d = (_c = options === null || options === void 0 ? void 0 : options.subdivisions) === null || _c === void 0 ? void 0 : _c.latitude) !== null && _d !== void 0 ? _d : 12);
        // Get the intersecting region of our requested 'region' and the tiling scheme's region. The provider can
        // only provide tiles from within the intersection of both regions.
        const region = (_e = options === null || options === void 0 ? void 0 : options.region) !== null && _e !== void 0 ? _e : Rectangle.MAX;
        if (this._tilingScheme.rectangle.intersects(region)) {
            this._region = this._tilingScheme.rectangle.intersection(region);
        }
        else {
            throw new Error("The requested 'region' does not intersect with 'tilingScheme.rectangle'");
        }
    }
    get tilingScheme() {
        return this._tilingScheme;
    }
    get region() {
        return this._region;
    }
    get attributions() {
        return [];
    }
    get minLevel() {
        return 0;
    }
    get maxLevel() {
        return 32;
    }
    loadTile(x, y, zoomLevel) {
        return __awaiter(this, void 0, void 0, function* () {
            const region = this.tilingScheme.tileXYToRectangle(x, y, zoomLevel);
            const result = this._tessellator.tessellateCartographicSection(region, this._subdivisions);
            const positionsF32 = new Float32Array(result.positions);
            const normalsF32 = new Float32Array(result.normals);
            const uvsF32 = new Float32Array(result.uvs);
            const indicesI16 = new Int16Array(result.indices);
            const geometry = new BufferGeometry();
            geometry.setAttribute("position", new BufferAttribute(positionsF32, 3));
            geometry.setAttribute("normal", new BufferAttribute(normalsF32, 3));
            geometry.setAttribute("uv", new BufferAttribute(uvsF32, 2));
            geometry.setIndex(new Uint16BufferAttribute(indicesI16, 1));
            geometry.computeBoundingSphere();
            // No skirt needed
            const skirtGeometry = new BufferGeometry();
            return [{ geometry, skirtGeometry, midpoint: result.midpoint }];
        });
    }
}
